import Link from 'next/link';
import styles from '../courses.module.scss';

// SAR is pegged to USD at this rate; ACF stores course price in USD.
const USD_TO_SAR_RATE = 3.75;

function formatSarPrice(usd) {
    const num = parseFloat(usd);
    if (!Number.isFinite(num)) return null;
    const sar = num * USD_TO_SAR_RATE;
    const rounded = Number.isInteger(sar) ? sar : parseFloat(sar.toFixed(2));
    return `${rounded} ريال`;
}

const CourseCard = ({ course }) => {
    const title = course.title?.rendered || "بدون عنوان";
    const description = course.excerpt?.rendered || "";
    // Robust image fetching from featured_image_urls or _embedded
    const image = course.featured_image_urls?.large ||
        course.featured_image_urls?.medium ||
        course._embedded?.['wp:featuredmedia']?.[0]?.source_url ||
        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=2940&auto=format&fit=crop";
    const level = course.acf?.level || "غير محدد";
    const duration = course.acf?.duration || "غير محدد";
    const instructor = course.acf?.instructor?.post_title || "فيجماوية";
    const isOpen = course.acf?.open; // true if "yes" or no data, false if "no"
    const isSoon = course.acf?.soon; // true if "yes" or no data, false if "no"
    const isFree = course.acf?.free === true;
    const priceSar = formatSarPrice(course.acf?.price);

    // Extract instructor details from instructor_data
    const instructorName = course.instructor_data?.title || instructor;
    const instructorImage = course.instructor_data?.featured_image_urls?.thumbnail || null;
    const instructorLink = course.instructor_data?.link || "#";

    return (
        <div className={`list-group-item bg-white my-3 border-0 rounded-4 p-0 h-100 shadow-sm ${styles.courseCard}`}>
            <div className={styles.cardImgWrapper}>
                {course.acf?.badge && (
                    <span className={styles.badge}>{course.acf.badge}</span>
                )}
                {isSoon ? (
                    <span className={`${styles.badge} bg-dark text-light`}>قريباً</span>
                ) : !isOpen ? (
                    <span className={`${styles.badge} bg-dark text-light`}>مغلق</span>
                ) : (
                    <span className={`${styles.badge} bg-dark text-light`}>مفتوح</span>
                )}

                <img
                    src={image}
                    alt={title}
                    loading="lazy"
                />
            </div>
            <div className={styles.cardBody + ' pb-0'}>
                <div className={styles.meta}>
                    {/* <span><i className="bi bi-bar-chart"></i> {level}</span> */}
                    <span className='text-muted'><i className="bi bi-clock"></i> {duration}</span>
                    {priceSar && (
                        <span className={styles.price}>
                            {isFree ? (
                                <>
                                    <span className={styles.priceStrike}>{priceSar}</span>
                                    <span className={styles.priceFree}>مجاني</span>
                                </>
                            ) : (
                                priceSar
                            )}
                        </span>
                    )}
                </div>
                <h3 className={styles.title}>
                    {isSoon ? (
                        <span>{title}</span>
                    ) : isOpen ? (
                        <Link href={`/services/courses/${course.id}`}>
                            {title}
                        </Link>
                    ) : (
                        <span>{title}</span>
                    )}
                </h3>
                <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />

                <div className={styles.footer + ' row align-items-center'}>
                    <div className='col-12 col-md-8'>
                        <Link href="#" className={`d-flex align-items-center gap-2 text-decoration-none text-dark ${styles.instructorLink}`} target="_blank" rel="noopener noreferrer">
                            <div className={styles.avatarPlaceholder + ' bg-light border-1 overflow-hidden d-flex align-items-center justify-content-center'} style={{ width: '36px', height: '36px', borderRadius: '50%' }}>
                                {instructorImage ? (
                                    <img src={instructorImage} alt={instructorName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                    <i className="bi bi-person-fill text-muted"></i>
                                )}
                            </div>
                            <span className="fw-medium">{instructorName}</span>
                        </Link>
                    </div>
                    {isSoon ? (
                        <button className="btn btn-sm btn-outline-dark rounded-pill px-3 col-12 col-md-4 mt-4 mt-md-0" disabled>
                            سيفتح قريباً
                        </button>
                    ) : (
                        isOpen ? (
                            <Link href={`/services/courses/${course.id}`} className="btn btn-sm btn-outline-dark rounded-pill px-3  col-12 col-md-4 mt-4 mt-md-0">
                                التفاصيل
                            </Link>
                        ) : (
                            <button className="btn btn-sm btn-outline-dark rounded-pill px-3  col-12 col-md-4 mt-4 mt-md-0" disabled>
                                سيفتح قريباً
                            </button>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default CourseCard;
